import React from "react";
import { useState } from "react";

import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useRecoilState, useResetRecoilState } from "recoil";

import { resaleFormData, selectedParticipant } from "@states/resale_submission";
import { batchUploadDocument, curatedUploadDocument } from "@states/resale_submission";

interface SubmitResalesDisclaimerProps {
  confirmationButtonText: string;
  onConfirmation: () => void;
  inputsValid: boolean;
  isSubmitting?: boolean;
}

export const SubmitResalesDisclaimer = ({
  confirmationButtonText,
  onConfirmation,
  inputsValid,
  isSubmitting,
}: SubmitResalesDisclaimerProps) => {
  const [infoWarranty, setInfoWarranty] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const confirmationButtonEnabled = infoWarranty && inputsValid;
  const resetList = useResetRecoilState(resaleFormData);
  const resetBatchDoc = useResetRecoilState(batchUploadDocument);
  const resetCuratedDoc = useResetRecoilState(curatedUploadDocument);
  const resetSelectedParticipant = useResetRecoilState(selectedParticipant);
  const [batchDoc] = useRecoilState(batchUploadDocument);
  const [participant] = useRecoilState(selectedParticipant);
  const navigate = useNavigate();
  const showClear = batchDoc !== undefined || participant !== undefined;

  const handleConfirmation = async () => {
    if (!confirmationButtonEnabled) {
      return;
    }

    onConfirmation();
  };

  const clearBatchFile = () => {
    resetBatchDoc();
    setModalShow(false);
  };

  return (
    <Container fluid>
      <Row>
        <Col>
          <Form.Group controlId="Agreements">
            <h5 className="mb-5">
              Ready to submit the completed reports{participant ? " for " + participant.company_name : ""}?
            </h5>
            <div className="d-flex flex-column gap-3 p-0">
              <Form.Check
                inline
                label={
                  <div>
                    I warrant that all the information I provided on this form is correct. <br />
                    I undertake to indemnify Copyright Agency against any liability incurred by Copyright Agency as a
                    direct or indirect result of a breach of the preceding warranty.
                    <br />I undertake to notify Copyright Agency if there are any changes to any of the information
                    provided on this form.
                  </div>
                }
                value="infoWarranty"
                name="infoWarranty"
                type="checkbox"
                id={`inline-radio-yes`}
                checked={infoWarranty}
                onChange={(e) => {
                  setInfoWarranty(e.currentTarget.checked);
                }}
              />
              <div className="mt-4">
                <Button disabled={!confirmationButtonEnabled || isSubmitting} onClick={handleConfirmation}>
                  {isSubmitting ? "Submitting..." : confirmationButtonText}
                </Button>
                {showClear && (
                  <Button variant="danger" className="ms-4" onClick={() => setModalShow(true)}>
                    {batchDoc !== undefined ? "Delete and reupload" : "Clear and restart"}
                  </Button>
                )}
              </div>
            </div>
          </Form.Group>
        </Col>
      </Row>
      <Modal show={modalShow} onHide={() => setModalShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title className="ms-auto pt-1">Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p>
            You are about to delete the entire file, this will delete all attached resales as well as an updates you
            have made.
          </p>
          <p>Are you sure you want to continue? </p>
        </Modal.Body>

        <Modal.Footer style={{ alignContent: "center", justifyContent: "center" }}>
          <Button variant="secondary" onClick={() => setModalShow(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              clearBatchFile();
              resetList();
              resetBatchDoc();
              resetCuratedDoc();
              resetSelectedParticipant();
              navigate(batchDoc !== undefined ? "/dashboard/recent-reports" : "/dashboard/report-new-resale");
            }}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};
